module.exports = __webpack_public_path__ + "img/0Q3A5008-11-Pano_L.f4d9bce1.jpg";